var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.classes,on:{"click":_vm.handleClick}},[(!_vm.wi)?[_vm._v("\n        "+_vm._s(_vm.icon)+"\n    ")]:_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }